import { NotificationOutlined } from '@ant-design/icons';

import { ReleasesButton } from './NewReleasesButton.style';

export const RELEASE_NOTES_URL =
  'https://guide.skyspecs.com/horizon/-MPobGVTLxgvA9kxtck7/whats-new';

export function NewReleasesButton() {
  return (
    <ReleasesButton
      icon={<NotificationOutlined />}
      shape="circle"
      title="What's New"
      href={RELEASE_NOTES_URL}
      target="_blank"
      rel="noopener noreferrer"
      data-testid="new-releases-button"
    />
  );
}
